import NewSignup from './container'

export default NewSignup
